module.exports = __webpack_public_path__ + "img/42.65bb1852.jpg";